export const TIP_LENGTH_LIMIT = 6;
export const ENTER_KEY = 'Enter';
